import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Box, Typography } from '@mui/material';
import { StyledSlider } from '../../Theme/StyledComponents';

const valuetext = (value) => `${value}Km`;

const KmDistanceSelector = function KmDistanceSelector({
  value = [0, 150],
  onChange = () => {},
  max = 150,
}) {
  const intl = useIntl();

  const marks = [
    {
      value: 0,
      label: '0Km',
    },
    {
      value: Math.ceil(max / 4) * 1,
      label: `${Math.ceil(max / 4) * 1}Km`,
    },
    {
      value: Math.ceil(max / 4) * 2,
      label: `${Math.ceil(max / 4) * 2}Km`,
    },
    {
      value: Math.ceil(max / 4) * 3,
      label: `${Math.ceil(max / 4) * 3}Km`,
    },
    {
      value: max,
      label: `${max}Km`,
    },
  ];

  return (
    <Box sx={{
      p: "16px 32px"
    }}>
      <Typography sx={{ fontSize: '14px', marginBottom: '16px' }}>
        {`${intl.messages.DISTANCE_KM}: ${intl.messages.BETWEEN} ${
          value && typeof value[0] !== 'undefined' ? value[0] : 0
        } ${intl.messages.AND} ${
          value && typeof value[1] !== 'undefined' ? value[1] : 150
        }`}
      </Typography>
      <StyledSlider
        providedColor="#1D5B9D"
        marks={marks}
        getAriaLabel={() => 'km-distance-slider'} //aria-label for accessibility
        value={value}
        onChange={onChange}
        min={0}
        max={max}
        valueLabelDisplay="auto"
        getAriaValueText={valuetext} //current value displayed in aria for accessibility
        valueLabelFormat={valuetext} //value displayed in onHover tooltip
        disableSwap
      />
    </Box>
  );
};

KmDistanceSelector.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func,
  max: PropTypes.number,
};

export default KmDistanceSelector;
